import { render } from "./imgSlider.vue?vue&type=template&id=2494d9ab"
import script from "./imgSlider.vue?vue&type=script&lang=js"
export * from "./imgSlider.vue?vue&type=script&lang=js"

import "./imgSlider.vue?vue&type=style&index=0&id=2494d9ab&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__